import {
	type GqlSuccessResponse,
	performGqlFetch,
} from '@atlassian/conversation-assistant-utils/graphqlUtils';

export const fetchAgg = async <T, U>({
	siteId,
	graphQuery,
	variables,
}: {
	siteId?: string;
	graphQuery: string;
	variables: U;
}): Promise<GqlSuccessResponse<T>> => {
	const response = await performGqlFetch<T, U>({
		gqlQuery: graphQuery,
		variables: {
			siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
			...variables,
		},
	});

	return response;
};
